import { render } from "./Questions.vue?vue&type=template&id=4d6c5d6f&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=4d6c5d6f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6c5d6f"]])

export default __exports__